import { lumi } from '@/lib/lumi'
import { useState } from 'react'

export function useUpload() {
  const [uploading, setUploading] = useState(false)

  const upload = async (file: File): Promise<string | null> => {
    setUploading(true)
    try {
      const result = await lumi.tools.file.upload(file)
      const url = Array.isArray(result) ? result[0]?.url : (result as any)?.url
      return url || null
    } catch (error) {
      console.error('Échec du téléversement:', error)
      return null
    } finally {
      setUploading(false)
    }
  }

  return { upload, uploading }
}
